import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ImageModal = ({ isOpen, onClose, imageUrl }) => {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <span>Image Preview</span>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <img src={imageUrl} alt="Large view" style={{ maxWidth: '100%', maxHeight: '80vh' }} />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ImageModal;